export default function Results({ data }) {
    if (!data) return null;

    const formatTrend = (trend) => {
        switch (trend) {
            case "strong_up": return "Strong Uptrend";
            case "weak_up": return "Moderate Uptrend";
            case "weak_down": return "Moderate Downtrend";
            case "strong_down": return "Strong Downtrend";
            default: return trend;
        }
    };

    const formatMomentum = (momentum) => {
        switch (momentum) {
            case "positive": return "Positive Momentum";
            case "negative": return "Negative Momentum";
            case "neutral": return "Neutral Momentum";
            default: return momentum;
        }
    };

    const formatVolatility = (vol) => {
        switch (vol) {
            case "high": return "High Volatility (Uncertain)";
            case "moderate": return "Moderate Volatility";
            case "low": return "Low Volatility (Stable)";
            default: return vol;
        }
    };

    return (
        <div>
            <h2>Result</h2>

            {data.period === "1mo" && (
                <div className="warning">
                    ⚠️ Short-term lookback period: signals may be more sensitive to recent price movements.
                </div>
            )}

            <div className="card">
                <p>
                    <strong>Regime: </strong>
                    <span
                        style={{
                            color:
                                data.regime === "Bullish"
                                    ? "green"
                                    : data.regime === "Bearish"
                                        ? "red"
                                        : "gray",
                            fontWeight: "bold",
                        }}
                    >
                        {data.regime}
                    </span>
                </p>
                <p>
                    <strong>Confidence: </strong> {data.confidence}%
                </p>
                <p className="disclaimer">
                    ⚠️ This tool is for educational purposes and does not constitute financial advice.
                </p>
            </div>

            <div className="card">
                <h3>Signals</h3>
                <ul>
                    <li>Trend: {formatTrend(data.signals.trend)}</li>
                    <li>Momentum: {formatMomentum(data.signals.momentum)}</li>
                    <li>Volatility: {formatVolatility(data.signals.volatility)}</li>
                </ul>
            </div>
            <div className="card">
                <h3>💡 Insights</h3>
                <p>{data.insights.trend}</p>
                <p>{data.insights.momentum}</p>
                <p>{data.insights.volatility}</p>
                <br />
                <p>
                    <em>{data.insights.macro}</em>
                </p>
            </div>
        </div>
    );
}